module.exports = __webpack_public_path__ + "static/AssertioSpecialtyPharmaceuticals-1064ae30637edf5948f0a38247d2b0be.png";